module.exports = __webpack_public_path__ + "img/161.0ebdd683.jpg";